import { demutate, mutate, mutationTypes, updateWord } from './mutationUtils';

export const lowercaseIncompleteMutations = {
  'k': 'c\'h',
};

const incompleteMutations = {
  'k': 'c\'h',
  'K': 'C\'H',
};

const reverseMutations = {
  'c\'h': 'k',
  'C\'H': 'K',
  'C\'h': 'K',
};

export const provokersIncompleteMutationsOnly = [
  'hor', 'er',
];

export function applyIncompleteMutations (wordToMutateIdx, words) {
  updateWord(words[ wordToMutateIdx ],
    (word) => {
      mutate(word, incompleteMutations, mutationTypes.INCOMPLETE);
    },
    (word) => {
      demutate(word, reverseMutations, mutationTypes.INCOMPLETE);
    });
}
